/**
 * Created by andrey on 26.02.19.
 */

const IslandView = cc.Node.extend({
    // eslint-disable-next-line no-unused-vars
    ctor: function (page, bundle) {
        this._super();

        this.bundle = bundle;

        this.page = page;

        page.onAnimateClose = this.createListener(this.animatePass.bind(this));
        page.onAnimateOpen = this.createListener(this.animateOpen.bind(this));
        page.onScroll = this.createListener(this.onScroll.bind(this));

        const animation = this.animation = this.islandAnimation();
        animation.setLocalZOrder(1);
        animation.setCascadeOpacityEnabled(true);
        this.addChild(animation);

        this.updateAnimation();

        this.addCharacters();

        this.setAnchorPoint(0.5, 0.5);

        this.onResize();

        if (this.page.isCurrent()) {
            this.addHighlight();
            this.addProgress(true);

            this.label = new CurrentEpisodeLabel(this.page.pageNo);
            this.addChild(this.label);

            this.makeIslandClickable();
        } else {
            this.addStatus(true);
        }

        this.addDecoration();

        if (cleverapps.config.debugMode && cleverapps.flags.islandsInfoEnabled) {
            const islandCenteringArea = new cc.Node();
            islandCenteringArea.setContentSize2(500, 300);
            animation.addChild(islandCenteringArea);
            islandCenteringArea.setAnchorPoint(0.5, 0.5);
            islandCenteringArea.debugBorder();

            // eslint-disable-next-line no-restricted-syntax
            const text = cleverapps.UI.generateTTFText(`Episode: ${this.page.pageNo}`, cleverapps.styles.FONTS.TEXT);
            animation.addChild(text);
        }

        this.scheduleUpdate();
    },

    onEnter: function () {
        this._super();

        if (this.parent.loading) {
            this.visible = false;
            this.runAction(new cc.Sequence(
                new cc.DelayTime(0.2),
                new cc.CallFunc(() => {
                    this.visible = true;
                })
            ));
        }
    },

    onResize: function () {
        const styles = cleverapps.styles.IslandView;
        this.setContentSize2(styles.width, styles.height);

        let positions = styles.positions;
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL && styles.positionsMobile) {
            positions = styles.positionsMobile;
        }
        this.setAlignment(positions[this.page.pageNo % Object.keys(positions).length]);

        this.animation.setAlignment(this.width / 2, this.height / 2);
    },

    islandAnimation: function () {
        return new cleverapps.Spine(this.bundle.jsons[`island_${this.page.pageNo}_json`]);
    },

    makeIslandClickable: function () {
        if (!this.clickHandler) {
            this.clickHandler = cleverapps.UI.onClick(this, () => {
                const currentLevel = cleverapps.user.getCurrentLevel();
                const level = new Level(currentLevel.episodeNo, currentLevel.levelNo);
                level.onPressed();
            });
        }
    },

    addCharacters: function () {
        const styles = cleverapps.styles.IslandEnemies;
        if (!styles || !styles[this.page.pageNo]) {
            return;
        }

        if (this.page.isPassed()) {
            this.addFriends();
        } else {
            this.addEnemies();
        }
    },

    addFriends: function (isBattle) {
        this.friends = this.createCharacters(true, isBattle);
        this.runCharactersAnimation(this.friends, isBattle ? "attack" : "idle");
    },

    addEnemies: function (isBattle) {
        this.enemies = this.createCharacters(false, isBattle);
        this.runCharactersAnimation(this.enemies, isBattle ? "attack" : "idle");
    },

    addHighlight: function () {
        if (this.islandHighlight) {
            return;
        }

        const islandHighlight = this.islandHighlight = new cleverapps.Spine(bundles.episodes_resources.jsons.island_highlight_json);
        islandHighlight.setAnimationAndIdleAfter("open", "animation");
        islandHighlight.setAlignment(this.width / 2, this.height / 2);
        this.addChild(islandHighlight);
    },

    removeHighlight: function () {
        if (this.islandHighlight) {
            this.islandHighlight.setAnimation(0, "close", false);
            this.islandHighlight.setCompleteListenerRemove();
        }
    },

    addStatus: function (silent) {
        if (this.statusBg) {
            return;
        }

        const styles = cleverapps.styles.IslandView.status;
        const statusBg = this.statusBg = new cc.Sprite(bundles.episodes_resources.frames.island_status_bg);
        statusBg.setLocalZOrder(2);
        statusBg.setAlignment(styles.positions[this.page.pageNo % Object.keys(styles.positions).length]);
        this.animation.addChild(statusBg);

        const json = this.page.isPassed() || this.page.isCurrent() ? "checkmark_json" : "padlock_json";
        const icon = new cleverapps.Spine(bundles.episodes_resources.jsons[json]);
        icon.setAlignment(statusBg.width / 2, statusBg.height / 2 + styles.icon.dy);
        statusBg.addChild(icon);
        icon.setAnimation(0, "idle", true);

        statusBg.icon = icon;

        if (!silent) {
            statusBg.setOpacity(0);
            statusBg.runAction(new cc.FadeIn(1));
            icon.setAnimationAndIdleAfter("open", "idle");
        }
    },

    removeStatus: function () {
        if (this.statusBg) {
            this.statusBg.icon.setAnimation(0, "open", false);

            this.statusBg.runAction(new cc.Sequence(
                new cc.FadeOut(0.5),
                new cc.CallFunc(() => {
                    delete this.statusBg;
                })
            ));
        }
    },

    addProgress: function (silent) {
        if (this.progress) {
            return;
        }

        const progress = this.progress = new ProgressView();
        progress.setLocalZOrder(1);
        this.addChild(progress);

        if (!silent) {
            progress.setScale(0.6);
            progress.setOpacity(0);

            progress.runAction(new cc.Spawn(
                new cc.ScaleTo(0.15, 1).easing(cc.easeBackOut()),
                new cc.FadeIn(0.15)
            ));
        }
    },

    removeProgress: function () {
        if (this.progress) {
            this.progress.runAction(new cc.Sequence(
                new cc.ScaleTo(0.15, 0.6).easing(cc.easeBackIn()),
                new cc.FadeOut(0.15),
                new cc.DelayTime(0.1),
                new cc.RemoveSelf(),
                new cc.CallFunc(() => {
                    delete this.progress;
                })
            ));
        }
    },

    runCharactersAnimation: function (characters, animation) {
        if (!characters) {
            return;
        }
        characters.forEach((character) => {
            const runAnimationNow = function () {
                if (animation === "idle") {
                    const characterAnimation = function () {
                        character.inAnimation = false;
                        character.setCompleteListener();
                        character.setAnimation(0, character.idleAnimation, true);
                        character.runAction(new cc.Sequence(new cc.DelayTime(Math.random() * 20 + 3), new cc.CallFunc(() => {
                            character.inAnimation = true;
                            character.setAnimation(0, character.attackAnimation, false);
                            character.setCompleteListener(characterAnimation);
                        })));
                    };
                    characterAnimation();
                }
                if (animation === "attack") {
                    character.inAnimation = true;
                    character.setAnimation(0, character.attackAnimation, true);
                }
                if (animation === "die") {
                    character.stopAllActions();
                    character.setAnimation(0, character.dieAnimation, false);
                    character.setCompleteListener(() => {
                        character.setCompleteListener();
                        character.runAction(new cc.Sequence(new cc.DelayTime(0.5), new cc.ScaleTo(0.3, 0), new cc.RemoveSelf()));
                    });
                    cleverapps.effects.fire("match3.episode.enemy.die");
                }
            };
            if (character.inAnimation) {
                character.setCompleteListener(runAnimationNow);
            } else {
                runAnimationNow();
            }
        });
    },

    createCharacters: function (isFriends, isBattle) {
        const styles = cleverapps.styles.IslandEnemies;
        const enemies = [];
        styles[this.page.pageNo].forEach(function (enemyStyle, id) {
            let delta = { x: 0, y: 0 };
            let spine = enemyStyle.enemy;
            let scale = styles.enemies.scale;
            let idleAnimation = styles.enemies.idleAnimation;
            let attackAnimation = styles.enemies.attackAnimation;
            const dieAnimation = styles.enemies.dieAnimation;
            let x = styles.enemies.x;
            let y = styles.enemies.y;
            if (isBattle) {
                delta = styles.enemies.delta;
            }
            if (isFriends) {
                const pseudo = PseudoRandom.GET("secondary");
                pseudo.seed(this.page.pageNo * 1000 + id);
                let color = pseudo.choose(Heroes.AVAILABLE_HEROES);
                color = color.toUpperCase();
                spine = cleverapps.skins.getSlot(`${color}_hero_spine_json`) || bundles.heroes.jsons[`${color}_hero_spine_json`];
                scale = styles.friends.scale;
                idleAnimation = styles.friends.idleAnimation;
                attackAnimation = styles.friends.attackAnimation;
                x = styles.friends.x;
                y = styles.friends.y;
                if (isBattle) {
                    delta = styles.friends.delta;
                }
            }
            const enemy = new cleverapps.Spine(spine);
            enemy.setScale(scale || 1.0);
            enemy.setSkin("regular");

            if (enemyStyle.flipped && !isBattle) {
                enemy.setScaleX(-enemy.scaleX);
            }
            enemy.setAlignment(enemyStyle.x + x + delta.x, enemyStyle.y + y + delta.y);
            // if (!spine.includes('goblin_5')) {
            enemy.setLocalZOrder(1);
            this.addChild(enemy);
            // }
            enemies.push(enemy);
            enemy.idleAnimation = idleAnimation;
            enemy.attackAnimation = attackAnimation;
            enemy.dieAnimation = dieAnimation;

            // Enemy debug information
            // eslint-disable-next-line no-restricted-syntax
            // var text = cleverapps.UI.generateTTFText("Episode: " + (this.page.pageNo + 1) + " x:" + enemyStyle.x +
            //     " y:" + enemyStyle.y, cleverapps.styles.FONTS.SMALL_WHITE_TEXT);
            // enemy.addChild(text);
        }, this);

        return enemies;
    },

    addDecoration: function () {
        if (!bundles.episodes_spines) {
            return;
        }
        let amountDecorations = 0;
        while (bundles.episodes_spines.jsons[`island_decor_${amountDecorations}`]) {
            amountDecorations++;
        }
        if (!amountDecorations) {
            return;
        }

        let styles = cleverapps.styles.IslandView;
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL && styles.decorPositionsMobile) {
            styles = styles.decorPositionsMobile;
        } else {
            styles = styles.decorPositions;
        }
        if (styles.disabled) {
            return;
        }

        styles = styles[this.page.pageNo % Object.keys(styles).length];

        const decorId = this.page.pageNo % amountDecorations;
        const decor = new cleverapps.Spine(bundles.episodes_spines.jsons[`island_decor_${decorId}`]);
        this.addChild(decor);
        decor.setAnimation(0, "animation", true);

        decor.setAlignment(this.width / 2 + styles.x, this.height / 2 + styles.y);
        if (styles.scaleX) {
            decor.setScaleX(styles.scaleX);
        }
    },

    updateAnimation: function (force) {
        let animation = force;
        if (!force) {
            animation = this.page.isOpened() ? "open" : "close";
        }

        this.animation.setAnimation(0, animation, true);
    },

    showBattle: function () {
        const styles = cleverapps.styles.IslandEnemies;

        if (!styles) {
            return;
        }

        const data = [{
            friend: false,
            characters: this.enemies,
            styles: styles.enemies
        }, {
            friend: true,
            characters: this.friends,
            styles: styles.friends
        }];

        data.forEach((item) => {
            let characters;

            if (!item.characters) {
                characters = this.createCharacters(item.friend, true);
                characters.forEach((character) => {
                    const scale = character.getScale();
                    character.setScale(0);
                    character.setAnimation(0, "idle", true);
                    character.runAction(new cc.Sequence(
                        new cc.ScaleTo(0.5, scale).easing(cc.easeIn(2)),
                        new cc.CallFunc(() => {
                            character.setAnimation(0, character.attackAnimation, true);
                            cleverapps.effects.fire("match3.episode.friend.attack");
                        })
                    ));
                });

                if (item.friend) {
                    this.friends = characters;
                } else {
                    this.enemies = characters;
                }
            } else {
                item.characters.forEach((character) => {
                    const pos = character.getPosition();
                    character.setScale(item.styles.scale || 1.0);
                    character.runAction(new cc.Sequence(
                        new cc.MoveTo(0.2, pos.x + item.styles.delta.x, pos.y + item.styles.delta.y).easing(cc.easeIn(2)),
                        new cc.CallFunc(() => {
                            character.setAnimation(0, character.attackAnimation, true);
                            cleverapps.effects.fire("match3.episode.enemy.attack");
                        })
                    ));
                });
            }
        });
    },

    animatePass: function (callback) {
        if (this.clickHandler) {
            this.clickHandler.remove();
            this.clickHandler = undefined;
        }

        this.showBattle();

        this.runAction(new cc.Sequence(new cc.DelayTime(1), new cc.CallFunc(() => {
            this.runCharactersAnimation(this.enemies, "die");
        })));
        this.runAction(new cc.Sequence(new cc.DelayTime(2), new cc.CallFunc(() => {
            this.runCharactersAnimation(this.friends, "idle");

            if (this.label && this.label.visible) {
                this.label.setScale(1);
                this.label.runAction(new cc.ScaleTo(0.5, 0).easing(cc.easeIn(2)));
            }

            this.removeProgress();
            this.removeHighlight();
            this.addStatus();
        })));
        this.runAction(new cc.Sequence(new cc.DelayTime(cleverapps.styles.IslandView.animatePass.delay), new cc.CallFunc(callback)));

        return true;
    },

    animateOpen: function (callback) {
        this.addHighlight();
        this.removeStatus();

        this.makeIslandClickable();

        this.runAction(new cc.Sequence(new cc.DelayTime(1.5), new cc.CallFunc(() => {
            if (!this.label) {
                this.label = new CurrentEpisodeLabel(this.page.pageNo);
                this.addChild(this.label);
            }
            this.label.setVisible(true);
            this.label.setScale(0);
            this.label.runAction(new cc.ScaleTo(0.5, 1).easing(cc.easeIn(2)));

            this.addProgress();

            callback();
        })));

        return true;
    },

    onScroll: function () {
    },

    update: function (dt) {
        this._super(dt);

        const y = this.convertToWorldSpace(this.getPosition()).y;
        if (this.savedY === y) {
            return;
        }

        let styles;
        let scales;
        let dist;
        const h = cleverapps.resolution.getSceneSize().height;

        if (cleverapps.config.name === "adventure") {
            dist = h - y;
            styles = cleverapps.styles.IslandView.adventure3d;
            scales = styles.scales;
            let scale;
            const maxScaleCoef = 1.8;
            if (dist < h / maxScaleCoef) {
                scale = scales[0] + scales[1] * dist / (h / maxScaleCoef);
            } else {
                scale = scales[0] + scales[1] * (h - dist) / (h - h / maxScaleCoef);
            }

            if ((this.animation.width + styles.padding.x) * scale > cleverapps.resolution.getSceneSize().width * 0.8) {
                scale = cleverapps.resolution.getSceneSize().width * 0.8 / (this.animation.width + styles.padding.x);
            }

            this.setScale(scale);
            this.baseScale = scale;
        } else {
            styles = cleverapps.styles.IslandView.runes3d;
            scales = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? styles.mobileScales : styles.scales;
            dist = h - y + this.parent.height / 2;
            let k = dist / h;
            k = k < 1 ? k : 1;
            let scaleX = k * scales[1] + scales[0];
            let scaleY = scaleX;
            if (styles.horizont) {
                scaleY = k * scales[1] + (k * (1 - styles.horizont.scale) + styles.horizont.scale) * scales[0];
            }

            if ((this.animation.width + styles.padding.x) * scaleX > cleverapps.resolution.getSceneSize().width * 0.8) {
                const oldScaleX = scaleX;
                scaleX = cleverapps.resolution.getSceneSize().width * 0.8 / (this.animation.width + styles.padding.x);
                scaleY = scaleY * scaleX / oldScaleX;
            }

            this.parent.setScale(scaleX, scaleY);
            this.parent.setLocalZOrder(-this.page.pageNo);
        }

        this.savedY = y;
    }
});

cleverapps.styles.IslandView = {
    width: 400,
    height: 300,

    positions: {
        0: {
            x: 150,
            y: 0
        },

        1: {
            x: -150,
            y: 0
        }
    },

    positionsMobile: {
        0: {
            x: -50,
            y: 0
        },

        1: {
            x: 50,
            y: 0
        }
    },

    decorPositions: {
        0: {
            x: 600,
            y: 0,
            scaleX: -1
        },

        1: {
            x: -600,
            y: 0
        }
    },

    decorPositionsMobile: {
        disabled: true
    },

    animatePass: {
        delay: 3.5
    },

    status: {
        positions: {
            0: {
                x: { align: "center", dx: 155 },
                y: { align: "center", dy: 100 }
            },

            1: {
                x: { align: "center", dx: 155 },
                y: { align: "center", dy: 100 }
            }
        },

        icon: {
            dy: 4
        }
    },

    runes3d: {
        scales: [0.8, 0.2],
        mobileScales: [0.8, 0.1],
        horizont: {
            scale: 0.7
        },
        padding: {
            x: 100
        }
    },

    adventure3d: {
        scales: [0.5, 1.0],
        padding: {
            x: 300
        }
    }
};